import { render } from "./BrandFilters.vue?vue&type=template&id=7962f553&scoped=true"
import script from "./BrandFilters.vue?vue&type=script&lang=js"
export * from "./BrandFilters.vue?vue&type=script&lang=js"

import "./BrandFilters.vue?vue&type=style&index=0&id=7962f553&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7962f553"]])

export default __exports__